import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKanban = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 2H10V22H14V2Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 2H2.5V22H6.5V2Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 2H17.5V22H21.5V2Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgKanban;
